import React from 'react';
import styles from './Footer.stylesheet.css';

const Footer = () =>
  <footer className={styles.Footer}>

  </footer>;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.component.js